import { defaultTo } from 'lodash-es';
import { formatNumber, formatScoreNumber } from '@/utils';

const DECIMAL_NUMBER = 1;

export const extractCurrentAndPrevious = (
  data: Record<string, number>[],
  keySum = 'sumCesScore',
  keyCount = 'countCesScoreResponses',
) => {
  const currentSum = defaultTo(data[0]?.[keySum], 0);
  const currentCount = defaultTo(data[0]?.[keyCount], 0);

  const currentAverage = currentSum && currentCount ? currentSum / currentCount : 0;

  const previousSum = defaultTo(data[1]?.[keySum], 0);
  const previousCount = defaultTo(data[1]?.[keyCount], 0);

  const previousAverage = previousSum && previousCount ? previousSum / previousCount : 0;

  const change = [currentAverage === 0, previousAverage === 0].some(Boolean)
    ? 0
    : ((currentAverage - previousAverage) / previousAverage) * 100;

  return {
    currentSum,
    currentCount,
    currentAverage: Number(formatNumber(currentAverage, DECIMAL_NUMBER)),
    previousSum,
    previousCount,
    previousAverage,
    change: Number(formatScoreNumber(change, DECIMAL_NUMBER)),
  };
};
